import { X } from "lucide-react";
import { FunnelList, brandColor } from "./fniShared";

export default function FniBrandFunnels({ sucursal, onPick, onClose }) {
  if (!sucursal) return null;
  return (
    <section className="surface p-4 mb-5" data-testid="fni-brand-funnels">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-display font-extrabold text-base">Sucursal {sucursal.name} · embudo por marca</h3>
        <button className="btn flex items-center gap-1" onClick={onClose} data-testid="fni-brand-funnels-close"><X size={14}/> Cerrar</button>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {sucursal.marcas.map((m, i) => {
          const c = brandColor(m.name);
          return (
            <div key={m.name} className="rounded-xl border border-gray-200 overflow-hidden" data-testid={`fni-brand-card-${i}`}>
              <div className="px-3 py-1.5 text-center font-extrabold text-sm"
                   style={{ background: c, color: c === "#f4c400" ? "#111827" : "#fff" }}>{m.name}</div>
              <div className="p-3">
                <FunnelList data={m} testid={`fni-brand-funnel-${i}`}
                            onPick={(stage) => onPick({ stage, sucursal: sucursal.name, marca: m.name })}/>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
